<template>
  <button
    class="text-button"
    :disabled="disabled"
    v-bind="$attrs"
    @click="$emit('click')"
  >
    <slot />

    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="24" width="2"></v-progress-circular>
    </v-overlay>
  </button>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss">
$primary: #1b559e;

.text-button {
  background: transparent;
  color: $primary;

  border-radius: 8px;

  border: none;
  cursor: pointer;

  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;

  line-height: 100%;
  letter-spacing: 0%;

  padding: 0;
  margin: 0;

  position: relative;

  &:disabled {
    color: gray;
    cursor: not-allowed;
  }

  ::v-deep .v-application {
    text-transform: none !important;
  }
}
</style>
